<div class="container fadeIn" *ngIf="consultancyList && consultancyList.length > 0">

  <div *ngIf="showTitles" class="row">
    <div class="col-12">
      <h2
        class="titleTextFont font-weight-normal text-center"
        style="font-size: 2.4rem"
        [ngStyle]="{ color: titlesColor ? titlesColor : '' }"
      >
        {{ title }}
      </h2>
    </div>
    <div *ngIf="subtitle" class="col-12">
      <h2
        class="font-weight-normal fadeIn text-center mb-3 subtitle-block"
        style="font-size: 1.5rem"
        [ngStyle]="{ color: secondaryColor ? secondaryColor : '' }"
      >
        {{ subtitle }}
      </h2>
    </div>
  </div>

  <div class="row">
    <div
      class="consultancyItem col-md-4 col-12 pointer"
      *ngFor="let consultancy of consultancyList"
    >
      <div class="itemImage hover-shadow" *ngIf="consultancy?.heroImageSmall">
        <picture>
          <source
            media="(max-width: 799px)"
            srcset="{{ consultancy?.heroImageSmall }}"
          />
          <img
            [src]="consultancy?.heroImageSmall"
            decoding="async"
            loading="lazy"
            alt="{{ consultancy.title }}"
          />
        </picture>
      </div>
      <div class="itemDetails">
        <p
          class="itemTitle hover-text-shadow textFont"
          [ngStyle]="{ color: linkColor ? linkColor : '' }"
        >
          {{ consultancy.title }}
        </p>
        <div class="price-container" *ngIf="consultancy.price || consultancy.priceGlobal">
          <span *ngIf="consultancy.price" class="text-info font-weight-bold">
            {{ consultancy.price }}
          </span>
          <span class="vertical-separator" *ngIf="consultancy.price && consultancy.priceGlobal"></span>
          <span class="text-price" *ngIf="consultancy.priceGlobal">
            {{ consultancy.priceGlobal }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="buttonText" class="col-md-10 offset-md-1 text-center">
    <button
      class="btn btn-info mt-0 mb-5"
      tabindex="0"
    >
      {{ buttonText }}
    </button>
  </div>

  <div
    class="row gap-2 px-3"
    *ngIf="btn1Active || btn2Active"
    [ngClass]="{
      'align-left': btn1Align === 'left',
      'align-center': btn1Align === 'center',
      'align-right': btn1Align === 'right'
    }"
  >
    <a
      *ngIf="btn1Active"
      [href]="btn1Link"
      class="btn btn-info btn-flex  col-auto"
    >
      {{ btn1Es }}
    </a>
    <a
      *ngIf="btn2Active"
      [href]="btn2Link"
      class="btn btn-info btn-flex col-auto"
    >
      {{ btn2Es }}
    </a>
  </div>

</div>
